import React from "react";
import "./end-modify-assignments.css";
import moment from 'moment-timezone';

const EndModifyAssignments = (props) => {
  const {
    assignmentEndDate,
    jobs,
    onEndAssignment,
    onExtendAssignment,
    getShiftsCount,
    user,
    userCanPostJobs,
    timezone,
  } = props;
  // Just a guarding for unexpected api-v1 response
  // Shift count can be equal to null on the initial render
  // Jobs could be empty if we navigate back to the past and user doesn't have any new assignments
  const allAssignmentsInThePast = () => {
    const today = moment().tz(timezone);
    const hasFutureJobs = jobs.filter(job => (
      moment(job.end_date).tz(timezone).isSameOrAfter(today, 'day')
    ));

    return !hasFutureJobs.length;
  };
  const shiftsCount = getShiftsCount(user.id) || 0;

  const filterBlueshiftJobs = jobs?.filter(job => !job.blueshift_request_id) || [];
  // Buttons will be disabled in two cases:
  // - if user only has blueshifts
  // - if user has no permissions for editing
  const disableButton = filterBlueshiftJobs.length === 0 || !userCanPostJobs;
  // Show tooltip only if buttons are disabled and user has permissions for editing
  const showTooltip = filterBlueshiftJobs.length === 0 && userCanPostJobs;
  return (
    <div
      data-testid="end-modify-assignments"
      className="end-modify-assignments-container"
    >
      <div className="end-modify-assignments-inner-container">
        <span className="font-styles-bold">{shiftsCount} future shifts</span>
        <span className="font-styles" style={{paddingTop: "6px", paddingBottom: "4px"}}>
          {assignmentEndDate ? 'until ' + assignmentEndDate : null}
        </span>
        <div className={`button-wrapper ${showTooltip && "button-tooltip"}`}>
          <button
            disabled={disableButton}
            className={`button-styles modify-button-styles ${disableButton && 'button-disabled'}`}
            onClick={() => onExtendAssignment(user)}
            data-pendo-key="roster-week-view-row-modify-button"
          >
            Modify
          </button>
          <button
            disabled={disableButton}
            data-testid="end-assignments-button"
            className={`button-styles end-button-styles ${disableButton && 'button-disabled'}`}
            onClick={() => onEndAssignment(user)}
            data-pendo-key="roster-week-view-row-end-button"
          >
            End
          </button>
          <div className="shift-tooltip">
            <span>
              Modify / End is used to change the end for repeating shift schedules
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EndModifyAssignments;
